import {convertToArray} from 'nutshell-core/filter';
import {Routing} from 'nutshell-core/routing';

/**
 * If we only have unknown params in the URL, we want to apply the default query but
 * still inlude the unknown params
 *
 * Example: When loading app.nutshell.com/scheduler with url parameters we don’t expect
 * (e.g. utm_source=nutshell) we need to both apply the correct defaults (e.g. view=board)
 * AND include the utms
 *
 * @param  {string} urlParamString - Current url param string
 * @param  {object} urlParams - Current url params as an object
 * @param  {?string} defaultQuery - Default query string
 * @return {?string} Returns a new default query string including the unknown params if no known params are included in the urlParams
 */
export const generateDefaultQueryIncludingUnknownParams = (
    urlParamString: string,
    urlParams: any,
    defaultQuery?: string
): string | null | undefined => {
    if (!defaultQuery || defaultQuery === '') {
        return `?${urlParamString}`;
    }

    if (urlParamString === '') {
        return defaultQuery;
    }

    // Get default query params based on default query
    const defaultQueryParams = convertToArray(Routing.deparam(defaultQuery.slice(1))).map(
        (obj) => Object.keys(obj)[0]
    );

    // Check if any of the default query params are defined
    // @ts-expect-error
    const definedParams = defaultQueryParams.find((param) => urlParams[param] !== undefined);

    // If none of the expected params are defined, return the default query with the unknown params included
    if (!definedParams) {
        return `${defaultQuery}&${urlParamString}`;
    }
};
